import { FlatList, View, StyleSheet, Image, Dimensions, Pressable, Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import * as Device from 'expo-device';

import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { doc, getFirestore, setDoc } from 'firebase/firestore';

Notifications.setNotificationHandler({
    handleNotification: async () => ({
        shouldShowAlert: true,
        shouldPlaySound: true,
        shouldSetBadge: false,
    }),
});



export default function Loader() {
    const [expoPushToken, setExpoPushToken] = useState('');
    const [notification, setNotification] = useState(false);
    const notificationListener = useRef();
    const responseListener = useRef();
    if (Platform.OS !== "web") {
        Notifications.setNotificationCategoryAsync('ApplyLeave', [
            {
                identifier: "leaveDeny",
                buttonTitle: 'Deny',
                options: {
                    isDestructive: true,
                    isAuthenticationRequired: false,
                    opensAppToForeground: false
                }
            },
            {
                identifier: "leaveApprove",
                buttonTitle: 'Approve',
                options: {
                    isDestructive: true,
                    isAuthenticationRequired: false,
                    opensAppToForeground: false
                }
            },
            {
                identifier: "leaveOpen",
                buttonTitle: 'Open App',
                options: {
                    isDestructive: true,
                    isAuthenticationRequired: false,
                    opensAppToForeground: true
                }
            }
        ]);
        Notifications.setNotificationCategoryAsync('ViewLeave', [
            {
                identifier: "leaveView",
                buttonTitle: 'OK',
                options: {
                    isDestructive: true,
                    isAuthenticationRequired: false,
                    opensAppToForeground: true
                }
            }
        ]);
    }
    const lastNotificationResponse = Notifications.useLastNotificationResponse();
    useEffect(() => {
        if (lastNotificationResponse) {
            if (lastNotificationResponse.actionIdentifier == "leaveDeny" || lastNotificationResponse.actionIdentifier == "leaveApprove") {
                //     //console.log("lastNotificationResponse.notification.request", lastNotificationResponse.notification.request)
                if (lastNotificationResponse.notification.request.content.data.data.id) {
                    const db = getFirestore()
                    const ref = doc(db, "Leaves", lastNotificationResponse.notification.request.content.data.data.id)
                    if (ref) {
                        setDoc(ref, { respondedOn: dayjs().unix(), status: lastNotificationResponse.actionIdentifier == "leaveApprove" ? 1 : 0 }, { merge: true })
                    }
                }
            }
            Notifications.dismissNotificationAsync(lastNotificationResponse.notification.request.identifier)
            //  //console.log("lastNotificationResponse " + lastNotificationResponse.userText, lastNotificationResponse)
        }
    }, [lastNotificationResponse]);

    useEffect(() => {
        setTimeout(async () => {
            if (Platform.OS == "android" || Platform.OS == "ios") {
                registerForPushNotificationsAsync().then(token => setExpoPushToken(token));

                notificationListener.current = Notifications.addNotificationReceivedListener(async notification => {
                    const data = notification.request.content.data
                    //     //console.log("noti data", data)
                    if (data?.notiType == "LEAVE") {
                        await Notifications.setNotificationChannelAsync('leaveRequest', {
                            name: 'Leave Request',
                            importance: Notifications.AndroidImportance.HIGH,
                            sound: 'noti1.mp3', // <- for Android 8.0+, see channelId property below
                        });
                        await Notifications.scheduleNotificationAsync({
                            content: {
                                subtitle: "Leave Request",
                                color: "orange",
                                sound: "noti1.mp3",
                                title: "Leave Request (" + data?.staffName + ") ⏱",
                                body: data?.type == "APPROVE" ?
                                    'Kindly approve ' + data?.leaveType + " " + data?.days + "." + (data?.reason ? "  Reason : " + data?.reason + ". " : "") + " 📝" :
                                    data.staffName + " has applied for leave " + data?.days,
                                data: { data: { id: data.id } },
                                categoryIdentifier: data?.type == "APPROVE" ? "ApplyLeave" : "ViewLeave",
                                vibrate: false
                            },
                            trigger: { seconds: 2, channelId: "leaveRequest" },
                        });
                    } else {
                        setNotification(notification);
                    }
                });

                responseListener.current = Notifications.addNotificationResponseReceivedListener(response => {
                });
            }

        })


        return () => {
            if (Platform.OS == "android" || Platform.OS == "ios") {
                Notifications.removeNotificationSubscription(notificationListener.current);
                Notifications.removeNotificationSubscription(responseListener.current);
            }
        };

    }, []);


    async function registerForPushNotificationsAsync() {
        let token;
        //   //console.log("noti reg started")
        if (Device.isDevice) {
            const { status: existingStatus } = await Notifications.getPermissionsAsync();
            let finalStatus = existingStatus;
            // //console.log("noti reg id device")

            if (existingStatus !== 'granted') {
                const { status } = await Notifications.requestPermissionsAsync();
                finalStatus = status;
                //   //console.log("noti reg permission granted")

            }
            if (finalStatus !== 'granted' && Platform.OS == "android" || Platform.OS == "ios") {
                alert('Failed to get push token for push notification!');
                return;
            }
            try {
                token = (await Notifications.getExpoPushTokenAsync()).data;
                //            //console.log("eas tocker ", token)
            } catch (e) {
                //         //console.log("eas tocker err", e)
            }
        } else {
            //      alert('Must use physical device for Push Notifications');
        }

        if (Platform.OS === 'android') {
            Notifications.setNotificationChannelAsync('leave', {
                name: 'default',
                importance: Notifications.AndroidImportance.MAX,
                vibrationPattern: [0, 250, 250, 250],
                lightColor: '#FF231F7C',
                sound: "notification.wav"
            });
        }

        return token;
    }



    return <></>

}

